module.exports = __webpack_public_path__ + "img/host-kritika.6c7b67f7.png";